import {trackOverlay} from '@aboutyou/legacy-tracking-sdk';
import {WithOptionalTypes} from '@aboutyou/utils';
import {useCallback} from 'react';
import {useTrackingPageContext} from '../context/PageTrackingContext';
import {useTracking} from '../utils/utils';

type TrackOverlayCallbackType = Omit<
  Parameters<typeof trackOverlay>[0],
  'page_type' | 'abtest_flag' | 'event'
>;

type TrackOverlayCallbackTypePartial = WithOptionalTypes<
  TrackOverlayCallbackType,
  'sponsored' | 'page_type_id' | 'event_scope'
>;

export type TrackOverlayParamsType = Pick<
  TrackOverlayCallbackTypePartial,
  'location_id' | 'page_type_id'
>;

export const useTrackOverlay = () => {
  const {TrackingClient} = useTracking();
  const {type: page_type} = useTrackingPageContext();

  return useCallback(
    ({
      page_type_id = '',
      sponsored = false,
      ...rest
    }: TrackOverlayCallbackTypePartial) => {
      TrackingClient.track(
        trackOverlay({
          page_type,
          page_type_id,
          sponsored,
          ...rest,
        }),
      );
    },
    [TrackingClient, page_type],
  );
};
